/* Prevent duplicate file names in ZIP */
export function getUniqueZipFilePath(filename: string, usedPaths: Set<string>): string {
  const sanitized = filename.trim() || "file";
  if (!usedPaths.has(sanitized)) {
    usedPaths.add(sanitized);
    return sanitized;
  }
  const lastDot = sanitized.lastIndexOf(".");
  const base = lastDot > 0 ? sanitized.slice(0, lastDot) : sanitized;
  const ext = lastDot > 0 ? sanitized.slice(lastDot) : "";
  let n = 2;
  let candidate = `${base} (${n})${ext}`;
  while (usedPaths.has(candidate)) {
    n += 1;
    candidate = `${base} (${n})${ext}`;
  }
  usedPaths.add(candidate);
  return candidate;
}
